import {defaults} from '../../constants/defaults';

export const DEFAULT_ZOOM_LEVEL = 9;
export const ICON_SIZE = [39, 39];
export const ICON_OFFSET = [-30, -60];
export const DEFAULT_CENTER_POINT = defaults.locality.geolocation;
